import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSportBall = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.999 2.655v18.69m-7.043-3.206a7.188 7.188 0 0 0 0-12.278m14.09 0a7.187 7.187 0 0 0 0 12.278M12 21.345A9.345 9.345 0 0 0 21.345 12 9.345 9.345 0 1 0 12 21.345"
      />
    </svg>
  );
};
export default SvgSportBall;
